import { SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";

import { Dashboard } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";
import { BaseViewProps } from "@/utils/TypesAndConstants";

export const CanceledDocumentsView = (props: BaseViewProps) => {
    const { lockedAccount } = props;
    const { connectedProfileId } = useAuthContext();
    optlog(`+++ CanceledDocumentsView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Documents résiliés"
            emptyMessage="Pas de documents résiliés"
            category="canceled"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver, SessionActorType.Signer]}
            lockedAccount={lockedAccount}
            sectionInfos={defaultSectionInformations} 
        />),
        false,
        "Impossible d'afficher la liste des documents résiliés, car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
